module.exports = __webpack_public_path__ + "img/sub4.2546b21a.png";